"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    type: Number,
    item: Object
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {
    lookDetails: function lookDetails(e) {
      console.log(e, 'ee');
      window.open(e.courseLink);
      aplus_queue.push({
        action: "aplus.record",
        arguments: ["course_click", "CLK", {
          //以下为事件属性
          course_name: e.courseName,
          // 课程名称
          course_id: e.newId ? e.newId : e.id,
          //课程id
          college_name: e.fkCourseEmceeSchool,
          // 所属学校
          major_name: e.fkCourseMajor // 所属专业
        }]
      });
    }
  }
};